import React from "react";

export const PaymentContext = React.createContext({});

export const PaymentProvider = PaymentContext.Provider;
